export function extractErrorMessage(error: unknown): string {
  if (!error) return 'An unexpected error occurred';
  const err = error as { response?: { data?: { message?: string | string[] } }; message?: string };
  const msg = err.response?.data?.message;
  if (Array.isArray(msg)) return msg.join('. ');
  if (typeof msg === 'string') return msg;
  if (typeof err.message === 'string') return err.message;
  return 'An unexpected error occurred';
}
